import Text from '@ui/text/text/text';

export default function TextAlertTitle({ children }: { children: React.ReactNode }) {
  return <Text className="H6 text-alert-title">{children}</Text>;
}
